<app-layout-crud-index
  [titulo]="title"
  [length]="length"
  [dataSource]="dataSource"
  [filterFields]="filterFields"
  [configColumns]="configColumns"
  [displayedColumns]="displayedColumns"
  (onChangePage)="changePage($event)"
  (onFilter)="filter($event)"
  (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
  (onOpenShow)="openShow($event)"
  (onOpenNew)="openNew($event)"
  (onOpenEdit)="openEdit($event)"
  (onOpenDelete)="openDelete($event)"
  (settings)="openSettings($event)"
  (onResetFilter)="resetFilter()"

  >
  <card-grid-responsive
    *ngIf="viewMode === 'cards'"
    table
    [length]="length"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (openShow)="openShow($event)"
    (openNew)="openNew($event)"
    (openEdit)="openEdit($event)"
    (openDelete)="openDelete($event)"
    [showLock]="true"
    [lockProperty]="'isActive'"
    (lock)="lock($event)"
    (unlock)="unlock($event)"
    (onSelectionChange)="onSelectionChange($event)"
    [showInfo]="true"
    [infoProperty]="'hasAudit'"
    (infoAction)="info($event)"
    [currentTab]="currentTab"
    [userType]="userType"
    [cardTitleProperty]="'system'"
    [cardImageProperty]="'image'"
    [cardSubtitleProperty]="'type'"
    [showBadge]="true"
    [badgeProperty]="'type'"
    [showCustomButton]="true"
    [customButtonIcon]="'table_view'"
    [customButtonTooltip]="'Alternar para visualização em tabela'"
    (customButtonClick)="toggleViewMode()"
    [isEditableShow]="permissionService.is(permissionService.systemActionRoles.PLAN_EDIT_BUTTON_SHOW)"
    [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.PLAN_EDIT_BUTTON_ENABLED)"
    [isDeletableShow]="permissionService.is(permissionService.systemActionRoles.PLAN_DELETE_BUTTON_SHOW)"
    [isDeletableEnabled]="permissionService.is(permissionService.systemActionRoles.PLAN_DELETE_BUTTON_ENABLED)"
    [isLockActionShow]="permissionService.is(permissionService.systemActionRoles.PLAN_LOCK_ACTION_SHOW)"
    [isLockActionEnabled]="permissionService.is(permissionService.systemActionRoles.PLAN_LOCK_ACTION_ENABLED)"
    [cardConfig]="{selectable: true}">
    <div *ngFor="let item of dataSource.data">
      <div *ngIf="item.isGeneralPlan" class="general-plan-badge">
        <mat-icon>public</mat-icon>
        <span>Plano Geral</span>
      </div>
    </div>
  </card-grid-responsive>

  <table-responsive
    *ngIf="viewMode === 'table'"
    table
    [length]="length"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (openShow)="openShow($event)"
    (openNew)="openNew($event)"
    (openEdit)="openEdit($event)"
    (openDelete)="openDelete($event)"
    [showLock]="true"
    [lockProperty]="'isActive'"
    (lock)="lock($event)"
    (unlock)="unlock($event)"
    (onSelectionChange)="onSelectionChange($event)"
    [showInfo]="true"
    [infoProperty]="'hasAudit'"
    (infoAction)="info($event)"
    [currentTab]="currentTab"
    [userType]="userType"
    [showCustomButton]="true"
    [customButtonIcon]="'grid_view'"
    [customButtonTooltip]="'Alternar para visualização em cards'"
    (customButtonClick)="toggleViewMode()"
    [isEditableShow]="permissionService.is(permissionService.systemActionRoles.PLAN_EDIT_BUTTON_SHOW)"
    [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.PLAN_EDIT_BUTTON_ENABLED)"
    [isDeletableShow]="permissionService.is(permissionService.systemActionRoles.PLAN_DELETE_BUTTON_SHOW)"
    [isDeletableEnabled]="permissionService.is(permissionService.systemActionRoles.PLAN_DELETE_BUTTON_ENABLED)"
    [isLockActionShow]="permissionService.is(permissionService.systemActionRoles.PLAN_LOCK_ACTION_SHOW)"
    [isLockActionEnabled]="permissionService.is(permissionService.systemActionRoles.PLAN_LOCK_ACTION_ENABLED)">
    <div *ngFor="let item of dataSource.data">
      <div *ngIf="item.isGeneralPlan" class="general-plan-badge">
        <mat-icon>public</mat-icon>
        <span>Plano Geral</span>
      </div>
    </div>
  </table-responsive>

  <div footer>
    <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4">
      <div fxFlex></div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex></div>
    </div>
  </div>
</app-layout-crud-index>